import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import { Button, Checkbox } from '@pella/sash-framework';

const PTIHSurvey = ({ inputChange, rep, canHaveAppt }) => {
	const { survey_prompts } = useStaticQuery(query).contentstackConversionConfig;
	const { questions, heading_group, start_survey } = survey_prompts;

	const [showSurvey, setShowSurvey] = useState(false);
	const onShowSurvey = (value) => setShowSurvey(value);

	return (
		<div className={`mb-6 flex flex-col bg-gray-5 p-6 ${showSurvey ? 'flex-col' : 'md:flex-row'}`}>
			<div>
				<h4 className='text-subtitle mb-2 font-bold'>{heading_group.heading}</h4>
				<p className={`text-subtitle ${showSurvey ? 'mb-6' : 'mb-2'}`}>
					{heading_group.subheading_part_1} {rep?.author_name?.split(' ')[0]} {heading_group.subheading_part_2} <span className='text-body-2 text-gray-60'>{heading_group.optional_text}</span>
				</p>
			</div>
			{!showSurvey && (
				<Button
					onClick={onShowSurvey}
					className='!w-auto !justify-start md:ml-auto'
					color='tertiary-alt'
					disabled={!canHaveAppt}
				>
					{start_survey}
				</Button>
			)}
			{showSurvey && (
				<ol className='text-body-2 m-0 py-0 pl-5 text-black'>
					<li>{questions[0].heading}</li>
					<ul className='mb-8 mt-0.5 list-none p-0'>
						<li className='mb-3 text-gray-60'>{questions[0].subheading}</li>
						<li>
							<Checkbox
								id='check_visualize'
								labelText={questions[0].answers[0]}
								type='checkbox'
								onChange={inputChange}
								name='replacement_visualization'
								groupClass='[&>label]:items-start [&>label>span]:mt-1 [&>label]:mb-3'
							/>
						</li>
						<li>
							<Checkbox
								id='check_offering'
								labelText={questions[0].answers[1]}
								type='checkbox'
								onChange={inputChange}
								name='product_offering'
								groupClass='[&>label]:items-start [&>label>span]:mt-1 [&>label]:mb-3'
							/>
						</li>
						<li>
							<Checkbox
								id='check_financing'
								labelText={questions[0].answers[2]}
								type='checkbox'
								onChange={inputChange}
								name='financing_offers'
								groupClass='[&>label]:items-start [&>label>span]:mt-1 [&>label]:mb-0'
							/>
						</li>
					</ul>
					<li>{questions[1].heading}</li>
					<ul className='flex list-none pl-1'>
						<li>
							<Checkbox
								id='timeframe_yes'
								labelText={questions[1].answers[0]}
								type='radio'
								name='timeframe'
								value='yes'
								onChange={inputChange}
								groupClass='mr-12'
							/>
						</li>
						<li>
							<Checkbox
								id='timeframe_no'
								labelText={questions[1].answers[1]}
								type='radio'
								name='timeframe'
								value='no'
								onChange={inputChange}
							/>
						</li>
					</ul>
					<li>{questions[2].heading}</li>
					<ul className='mb-2 flex list-none pl-1'>
						<li>
							<Checkbox
								id='installation_yes'
								labelText={questions[2].answers[0]}
								type='radio'
								name='installation'
								value='yes'
								onChange={inputChange}
								groupClass='mr-12'
							/>
						</li>
						<li>
							<Checkbox
								id='installation_no'
								labelText={questions[2].answers[1]}
								type='radio'
								name='installation'
								value='no'
								onChange={inputChange}
							/>
						</li>
					</ul>
				</ol>
			)}
		</div>
	);
};

PTIHSurvey.propTypes = {
	inputChange: PropTypes.func.isRequired,
	rep: PropTypes.object.isRequired,
	canHaveAppt: PropTypes.bool.isRequired,
};

export default PTIHSurvey;

export const query = graphql`
	query {
		contentstackConversionConfig {
			survey_prompts {
				start_survey
				questions {
					answers
					heading
					question_number
					subheading
				}
				heading_group {
					heading
					optional_text
					subheading_part_1
					subheading_part_2
				}
			}
		}
	}
`;
